import "./includes/scss/style.scss";
import "./includes/css/mmenu-light.css";

import Lenis from '@studio-freight/lenis';

import Splide from '@splidejs/splide';
import './includes/css/splide-core.min.css';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

import MmenuLight from 'mmenu-light';

import $ from 'jquery';

import { jarallax, jarallaxVideo } from "jarallax";
import 'jarallax/dist/jarallax.min.css';

import { Loader } from "@googlemaps/js-api-loader"

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

import AOS from 'aos';
import 'aos/dist/aos.css';

import vhCheck from 'vh-check';

import Macy from 'macy';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";


Fancybox.bind("[data-fancybox]", {
});

vhCheck('browser-address-bar');

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);



// init lenis
const lenis = new Lenis();

function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
}

requestAnimationFrame(raf)


// abilita lo scrollto di lenis nelle ancore
document.addEventListener("DOMContentLoaded", function () {
    var anchors = document.querySelectorAll('a[href^="#"]');

    var verticalSlider = document.querySelector('.g-container');

    if (!verticalSlider) {
        anchors.forEach(function (item) {
            item.addEventListener('click', function (e) {
                e.preventDefault();
                lenis.scrollTo(item.getAttribute('href'));
            })
        })
    }

})

// mobile menu

// rimozione shift menu
$(document).ready(function () {
    // elimina il layout shift del menu mobile
    setTimeout(function () {
        $(".mobile-menu").removeClass("hide");
    }, 350);
});

document.addEventListener("DOMContentLoaded", () => {

    const menu = new MmenuLight(
        document.querySelector(".mobile-menu"),
        "(max-width: 1500px)"
    );

    const navigator = menu.navigation();

    const drawer = menu.offcanvas({
        position: "right",
    });

    document.querySelector(".mobile-menu-wrap").addEventListener("click", (event) => {
        event.preventDefault();
        drawer.open();
    });
    document
        .querySelector(".trigger-close")
        .addEventListener("click", (event) => {
            event.preventDefault();
            drawer.close();
        });
});



// desktop menu
document.addEventListener("DOMContentLoaded", () => {

    var burgerIcon = document.querySelector(".burger-menu, .menu-icon__checkbox");
    var burgerMobileIcon = document.querySelector(".menu-lines-wrap");
    var slideMenu = document.querySelector(".slide-menu");
    var header = document.querySelector(".primary-menu");
    var slideMenu = document.querySelector(".slide-menu");
    var lastScrollTop = 0;
    let dropdownLinks = document.querySelectorAll('.primary-menu .has-children');


    const handleMouseWheel = function (event) {
        if (slideMenu.contains(event.target)) {
            slideMenu.scrollBy({
                top: event.deltaY,
            });
            event.preventDefault();
        }
    };

    document.addEventListener('wheel', handleMouseWheel, { passive: false });


    dropdownLinks.forEach(link => {
        let showTimeout, hideTimeout;

        link.addEventListener('mouseover', () => {
            clearTimeout(hideTimeout);
            clearTimeout(showTimeout);

            let dropdown = link.querySelector('.dropdown-wrap');
            if (dropdown) {
                dropdown.style.display = 'block';
            }

            showTimeout = setTimeout(() => {
                link.classList.add('is_active');
            }, 200);
        });

        link.addEventListener('mouseleave', () => {
            clearTimeout(showTimeout);
            clearTimeout(hideTimeout);

            link.classList.remove('is_active');

            let dropdown = link.querySelector('.dropdown-wrap');
            hideTimeout = setTimeout(() => {
                if (dropdown) {
                    dropdown.style.display = 'none';
                }
            }, 400);
        });
    });

    // funzione per gestire il menu allo scroll
    window.addEventListener("scroll", () => {
        document.documentElement.style.setProperty(
            "--scroll-y",
            `${window.scrollY}px`
        );
    });

    function handleScroll() {
        var st = window.scrollY || document.documentElement.scrollTop;
        let offset = window.innerWidth <= 767 ? 20 : 200;

        if (header && st > lastScrollTop && st > offset) {
            header.classList.add("shrink");
            burgerIcon.classList.add("shrink");
            burgerMobileIcon.classList.add("shrink");
            slideMenu.classList.add("shrink");
        }/*  else if (header && st < lastScrollTop) {
                header.classList.remove("shrink");
            } */

        if (window.scrollY == 0) {
            header.classList.remove("shrink");
            burgerIcon.classList.remove("shrink");
            burgerMobileIcon.classList.remove("shrink");
            slideMenu.classList.remove("shrink");
        }

        lastScrollTop = st;

    }

    var isOpen = false;
    burgerIcon.addEventListener("click", () => {
        slideMenu.classList.toggle("is__active");
        header.classList.toggle("is__active");
        if (isOpen) {
            lenis.start();
        } else {
            lenis.stop();
        }
        isOpen = !isOpen;
    });

    window.addEventListener("scroll", () => {
        handleScroll();
    });

});





document.addEventListener('DOMContentLoaded', function () {

    var currentUrl = window.location.href;
    var baseUrl;

    if (currentUrl.indexOf("/de/") !== -1) {
        baseUrl = "/de/";
    } else if (currentUrl.indexOf("/en/") !== -1) {
        baseUrl = "/en/";
    } else {
        baseUrl = "/";
    }

    // Iubenda Contatti
    if ($("#cf7_submit_contatti").length) {
        document.getElementById("cf7_submit_contatti").onclick = function () {
            sendToConsentSolution();
        };
        function sendToConsentSolution() {
            _iub.cons_instructions.push([
                "submit",
                {
                    form: {
                        selector: document.getElementById("form-contatti"),
                        map: {
                            subject: {
                                first_name: "your-name",
                                last_name: "Cognome",
                                email: "your-email",
                            },
                            preferences: {
                                privacy_policy: "acceptance-162",
                                type: "tipo",
                                telefono: "Telefono",
                            },
                        },
                    },
                    consent: {
                        legal_notices: [
                            {
                                identifier: "privacy_policy",
                            },
                        ],
                    },
                },
            ]);
        }
    }

    if ($(".contact-form").length) {
        $(document).ready(function () {
            $(".contact-form .form-group .check-container .wpcf7-list-item input").after(
                '<span class="wpcf7-list-item-label"></span>'
            );
        });
    }

    document.addEventListener(
        "wpcf7mailsent",
        function (event) {
            location = "https://" + window.location.host + baseUrl + "thank-you/";
        },
        false
    );

    // animazione placeholder form
    $("input, textarea").focus(function () {
        $(this).parents(".form-group p").addClass("focused");
    });

    $("input, textarea").blur(function () {
        var inputValue = $(this).val();
        if (inputValue == "") {
            $(this).removeClass("filled");
            $(this).parents(".form-group p").removeClass("focused");
        } else {
            $(this).addClass("filled");
        }
    });

})


// stile recaptcha
/* document.addEventListener("DOMContentLoaded", () => {
    var recaptcha = document.querySelector(".grecaptcha-badge");
    if (recaptcha) {
        setTimeout(() => {
            recaptcha.classList.add("custom-recaptcha");
        }, 800);
    }

}); */


jarallax(document.querySelectorAll('.jarallax'), {
    speed: 0.3,
});



document.addEventListener("DOMContentLoaded", () => {

    const numbers = document.querySelectorAll('.statistics .col-wrap.numbers');

    if (numbers.length) {

        numbers.forEach((number) => {
            const numeroValue = parseFloat(number.querySelector('.numero').textContent) || 0;

            const translateY = 100 - numeroValue;

            var filler = number.querySelector('.filler');

            ScrollTrigger.create({
                trigger: number,
                start: "top center+=200px",
                end: "bottom top+=200px",
                //markers: true,
                pinSpacing: true,
                onEnter: () => {
                    filler.style.height = numeroValue + "%";
                },
                onLeave: () => {
                    filler.style.height = 0 + "%";
                },
                onEnterBack: () => {
                    filler.style.height = numeroValue + "%";
                },
                onLeaveBack: () => {
                    filler.style.height = 0 + "%";
                },
            });

        });

    }


})




// effetto incremento sui numeri
document.addEventListener("DOMContentLoaded", function () {
    var nbrs = document.getElementsByClassName("__nia");
    if (nbrs.length) {

        let observer = new IntersectionObserver(function (entries, observer) {
            var speed = 20;

            function incEltNbr(elt) {
                let endNbr = Number(elt.innerHTML.match(/\d+/)[0]);
                let remainingText = elt.innerHTML.replace(/[0-9]/g, "");
                incNbrRec(0, endNbr, elt, remainingText);
            }

            function incNbrRec(i, endNbr, elt, remainingText) {
                if (i <= endNbr) {

                    elt.innerHTML = `<span>${i}</span>${remainingText.trim()}`;
                    setTimeout(function () {
                        incNbrRec(i + 1, endNbr, elt, remainingText);
                    }, speed);
                }
            }
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const element = entry.target;
                    incEltNbr(element);
                    observer.unobserve(element);
                }
            });
        });

        Array.from(nbrs).forEach((elt) => {
            observer.observe(elt);
        });
    }
});


document.addEventListener("DOMContentLoaded", function () {
    let links = document.querySelectorAll('.post-type-list .list-wrap .page');

    if (links.length) {
        let x = window.matchMedia("(min-width: 1301px)");
        if (x.matches) {
            function setImageWrapHeight() {
                let imageWrap = document.querySelector('.post-type-list .image-wrap');
                let listWrap = document.querySelector('.post-type-list .list-wrap');
                const height = imageWrap.offsetHeight;
                if (imageWrap) {

                    imageWrap.style.maxHeight = `${height}px`;
                    imageWrap.style.minHeight = `${height}px`;
                }
                if (listWrap) {
                    listWrap.style.maxHeight = `${height}px`;
                    listWrap.style.minHeight = `${height}px`;
                }
            }

            setImageWrapHeight();
            window.addEventListener('resize', setImageWrapHeight);
        }

        links.forEach(link => {
            link.addEventListener('mouseenter', function () {

                links.forEach(l => l.classList.remove('is-active'));

                this.classList.add('is-active');

                const index = this.getAttribute('data-index');

                const images = document.querySelectorAll('.image-wrap img');
                images.forEach(img => {
                    img.style.opacity = '0';
                    img.style.zIndex = '-1';

                    setTimeout(() => {
                        if (img.id === `image-${index}`) {
                            img.style.opacity = '1';
                            img.style.zIndex = '1';
                        }
                    }, 50);
                });
            });
        });

    }


});





document.addEventListener("DOMContentLoaded", function () {
    var mapContainer = document.querySelector(".map-container");

    if (mapContainer) {
        const locationsWrap = document.querySelector('.locations-wrap');

        if (locationsWrap) {
            const lenis = new Lenis({
                wrapper: locationsWrap,
                content: locationsWrap,
                smoothWheel: true,
                smoothTouch: false,
                duration: 1.2,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            })

            function raf(time) {
                lenis.raf(time)
                requestAnimationFrame(raf)
            }

            requestAnimationFrame(raf)
        }

        const apiKey = "AIzaSyBfbIfU-44PSTFw1cMA3ilUMlCmz_N8gVM";
        const mapId = "c2a0a15bfaaa03ff";
        const center = { lat: 43.769290967987885, lng: 11.261910069117745 };

        let x = window.matchMedia("(max-width: 500px)");

        var zoom = 7;

        if (x.matches) {
            zoom = 6;
        }

        var locations = document.querySelectorAll(".map .locations-wrap .location");
        var secondaryLocations = document.querySelectorAll(".map .sedi-secondarie .location");
        let map;

        async function initMap() {
            const loader = new Loader({
                apiKey: apiKey,
                version: "weekly",
            });

            loader.load().then(async () => {
                const { Map } = await google.maps.importLibrary("maps");
                const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

                map = new Map(document.getElementById("mappa-contatti"), {
                    center: center,
                    zoom: zoom,
                    mapId: mapId,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    streetViewControl: false,
                });

                secondaryLocations.forEach((location, i) => {
                    const icon = location.getAttribute('data-icon');
                    const coordinateString = location.getAttribute('data-coordinate');
                    const [lat, lng] = coordinateString.split(',').map(coord => parseFloat(coord.trim()));
                    const markerWrap = document.createElement('div');

                    if (i === 0) {
                        markerWrap.classList.add('is-active');
                    }

                    const markerImg = document.createElement('img');
                    markerImg.src = icon;
                    markerWrap.appendChild(markerImg);
                    const marker = new AdvancedMarkerElement({
                        map,
                        position: { lat, lng },
                        content: markerWrap,
                    });
                });

                locations.forEach((location, i) => {
                    const icon = location.getAttribute('data-icon');
                    const coordinateString = location.getAttribute('data-coordinate');
                    const [lat, lng] = coordinateString.split(',').map(coord => parseFloat(coord.trim()));
                    const markerWrap = document.createElement('div');
                    markerWrap.classList.add('marker-wrap');

                    if (i === 0) {
                        markerWrap.classList.add('is-active');
                    }

                    markerWrap.setAttribute("data-id", "marker-" + (i + 1));
                    markerWrap.style.cursor = 'pointer';
                    const markerImg = document.createElement('img');
                    markerImg.src = icon;
                    markerWrap.appendChild(markerImg);
                    const marker = new AdvancedMarkerElement({
                        map,
                        position: { lat, lng },
                        content: markerWrap,
                    });

                    markerWrap.addEventListener('gmp-click', (e) => {
                        e.stopPropagation(); // Impedisci la propagazione dell'evento alla mappa
                        handleMarkerClick(markerWrap);
                    });

                    marker.addListener('gmp-click', () => {
                        handleMarkerClick(markerWrap);
                    });
                });

                map.addListener('gmp-click', handleMapClick);
            });
        }

        //initMap();

        // --- Controlla se l'utente ha dato consenso a purpose 2 (Enhancement/Maps) ---
        function hasUserAcceptedPurpose2() {
            const match = document.cookie.match(/_iub_cs-\d+=([^;]+)/);
            if (!match) return false;
            try {
                const consent = JSON.parse(decodeURIComponent(match[1]));
                return consent.purposes && consent.purposes["2"] === true;
            } catch (e) {
                return false;
            }
        }

        // --- Polling finché l’utente accetta ---
        const poll = setInterval(() => {
            if (hasUserAcceptedPurpose2()) {
                clearInterval(poll);
                initMap();
            }
        }, 500);

        setTimeout(() => {
            document.querySelector('.yNHHyP-marker-view').classList.add('is-active');
        }, 1000);

        function handleMarkerClick(markerWrap) {

            document.querySelectorAll('.marker-wrap.is-active, .location.is-active')
                .forEach(el => el.classList.remove('is-active'));
            document.querySelectorAll('.yNHHyP-marker-view')
                .forEach(el => el.classList.remove('is-active'));


            markerWrap.classList.add('is-active');
            markerWrap.closest('.yNHHyP-marker-view').classList.add('is-active');

            const markerId = markerWrap.getAttribute('data-id');



            if (window.matchMedia("(max-width: 1100px)").matches && window.splideInstance) {
                const slideIndex = parseInt(markerId.replace('marker-', '')) - 1;
                window.splideInstance.go(slideIndex);
            } else {

                const targetLocation = document.querySelector(`.location[data-id="${markerId}"]`);
                if (targetLocation) {
                    targetLocation.classList.add('is-active');
                    targetLocation.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest'
                    });
                }
            }
        }

        function handleMapClick(e) {
            e.stopPropagation();
        }

        locationsWrap.querySelectorAll('.location').forEach((location, index) => {
            location.addEventListener('click', function () {
                document.querySelectorAll('.marker-wrap.is-active').forEach(marker => {
                    marker.classList.remove('is-active');
                    marker.closest('.yNHHyP-marker-view').classList.remove('is-active');
                });

                document.querySelectorAll('.location.is-active').forEach(loc => {
                    loc.classList.remove('is-active');
                });

                const markerId = this.getAttribute('data-id');
                const markerWrap = document.querySelector(`.marker-wrap[data-id="${markerId}"]`);
                if (markerWrap) {
                    markerWrap.classList.add('is-active');
                    markerWrap.closest('.yNHHyP-marker-view').classList.add('is-active');
                }

                this.classList.add('is-active');
            });

            if (index === 0) {
                location.classList.add('is-active');
            }
        });
    }
});




// gestione scroll sedi
document.addEventListener("DOMContentLoaded", function () {
    var locationsWrap = document.querySelector(".locations-wrap");

    let x = window.matchMedia("(min-width: 1101px)");

    function isTablet() {
        return /iPad|Android|Tablet/i.test(navigator.userAgent);
    }

    if (locationsWrap && x.matches && !isTablet()) {

        locationsWrap.addEventListener("mouseover", function () {
            lenis.stop();
            this.addEventListener('wheel', (event) => {
                this.scrollTop += event.deltaY;
                event.preventDefault();
            }, { passive: false });
        })

        locationsWrap.addEventListener("mouseleave", function () {
            lenis.start();
        })

    }
});



// map locations
document.addEventListener("DOMContentLoaded", function () {
    var locationsSlider = document.querySelector(".locations-wrap-mobile");
    let x = window.matchMedia("(max-width: 1100px)");

    if (locationsSlider && x.matches) {
        window.splideInstance = new Splide(".locations-wrap-mobile", {
            type: 'loop',
            padding: {
                left: 0,
                right: '5rem'
            },
            perPage: 2,
            gap: '1rem',
            pagination: false,
            autoHeight: true,
            arrows: false,
            perMove: 1,
            focus: 0,
            speed: 500,
            breakpoints: {
                600: {
                    perPage: 1
                }
            }
        }).mount();

        // sincronizzazione click marker con slider
        document.addEventListener('click', function (e) {
            const markerWrapper = e.target.querySelector('.marker-wrap');

            if (markerWrapper) {
                const markerId = markerWrapper.getAttribute('data-id');
                const slideIndex = parseInt(markerId.replace('marker-', '')) - 1;

                splideInstance.go(slideIndex);
            }
        });

        // sincronizzazione movimento slider con marker
        splideInstance.on('moved', function (newIndex) {

            document.querySelectorAll('.marker-wrap.is-active').forEach(marker => {
                marker.classList.remove('is-active');
                marker.closest('.yNHHyP-marker-view').classList.remove('is-active');
            });

            document.querySelectorAll('.location.is-active').forEach(loc => {
                loc.classList.remove('is-active');
            });

            const markerId = `marker-${newIndex + 1}`;
            const markerWrap = document.querySelector(`.marker-wrap[data-id="${markerId}"]`);
            if (markerWrap) {
                markerWrap.classList.add('is-active');
                markerWrap.closest('.yNHHyP-marker-view').classList.add('is-active');
            }

            const location = document.querySelector(`.location[data-id="${markerId}"]`);
            if (location) {
                location.classList.add('is-active');
            }
        });
    }
});


/* document.addEventListener("DOMContentLoaded", function () {
    let x = window.matchMedia("(min-width: 768px)");

    let sectionBanner = document.querySelector('section.banner');

    if (sectionBanner && x.matches) {
        let bannerWrap = sectionBanner.querySelector('.banner-wrap');
        const height = bannerWrap.offsetHeight;

        function wrapSwipeUpContent() {
            const swipeElements = document.querySelectorAll('.swipe-up');
            swipeElements.forEach(element => {
                const content = element.innerHTML;
                const wrapper = document.createElement('div');
                wrapper.className = 'content__wrapper';
                wrapper.innerHTML = content;
                element.innerHTML = '';
                element.appendChild(wrapper);
                const contentHeight = wrapper.offsetHeight;
                element.style.height = `${contentHeight}px`;
            });
        }

        wrapSwipeUpContent();
        window.addEventListener('resize', wrapSwipeUpContent);

        const bannerAnimation = ScrollTrigger.create({
            trigger: "section.banner",
            start: "top top",
            end: "150% bottom",
            pin: true,
            pinSpacing: true,
            //once: true,
            onEnter: () => {
                lenis.stop();
                setTimeout(() => {
                    gsap.to(".overlay-wrap", {
                        maskSize: '200%',
                        opacity: 0,
                        duration: 1.5,
                    });
                }, 100);
                gsap.to(".banner-wrap", {
                    backgroundColor: 'transparent',
                    duration: 1.5,
                    ease: "power3.inOut"
                });

                setTimeout(() => {
                    gsap.set(".swipe-up .content__wrapper", {
                        y: 0,
                    })

                    gsap.set(".swipe-up", {
                        opacity: 1,
                    })

                    gsap.set(".swipe-up .content__wrapper", {
                        y: 0,
                        ease: "power2.out"
                    });
                    lenis.start();

                }, 1500);
            },
            onEnterBack: () => {
                lenis.stop();

                gsap.set(".swipe-up .content__wrapper", {
                    y: '100%',
                })

                gsap.set(".swipe-up", {
                    opacity: 0,
                })

                gsap.set(".swipe-up .content__wrapper", {
                    y: '100%',
                    ease: "power2.out"
                });

                setTimeout(() => {
                    gsap.to(".overlay-wrap", {
                        maskSize: '10%',
                        opacity: 1,
                        duration: 1,
                    });
                    gsap.to(".banner-wrap", {
                        backgroundColor: 'white',
                        duration: 1,
                        ease: "power3.inOut"
                    });

                    lenis.start();
                }, 500);

            },
            onLeaveBack: () => {
                lenis.stop();

                gsap.set(".swipe-up .content__wrapper", {
                    y: '100%',
                })

                gsap.set(".swipe-up", {
                    opacity: 0,
                })

                gsap.set(".swipe-up .content__wrapper", {
                    y: '100%',
                    ease: "power2.out"
                });

                setTimeout(() => {
                    gsap.to(".overlay-wrap", {
                        maskSize: '10%',
                        opacity: 1,
                        duration: 1,
                    });
                    gsap.to(".banner-wrap", {
                        backgroundColor: 'white',
                        duration: 1,
                        ease: "power3.inOut"
                    });

                    lenis.start();
                }, 500);

            }

        });
    }
}); */


// animazione infografica gruppo

document.addEventListener("DOMContentLoaded", function () {


    if (document.querySelector('section.group-info')) {

        var $circle = $('.circle');
        var type = 1; //tipo di cerchio - 1 intero, 0.5 mezzo, 0.25 un quarto
        var start = 248; //shift inizia da 0
        var $elements = $('.circle .dots-wrap .dot');
        const dots = document.querySelectorAll('.dots-wrap .dot');
        var $images = $('.circle-images .images-wrap img');
        var numberOfElements = (type === 1) ? $elements.length : $elements.length - 1;
        var slice = 360 * type / numberOfElements;
        var squashCoefficient = 0.90; // coefficiente di schiacciamento per le immagini (1 = cerchio, < 1 = ellisse)


        /* dots.forEach(dot => {
            dot.addEventListener('click', function (event) {
                event.preventDefault();
            });
        }); */


        function updatePositions() {
            var radius = $circle.width() / 2;
            var radius_img = ($circle.width() / 2) + 50;

            // aggiorna le posizioni degli elementi (dot)
            $elements.each(function (i) {
                var $self = $(this),
                    rotate = slice * i + start,
                    rotateReverse = rotate * -1;

                $self.css({
                    'transform': 'rotate(' + rotate + 'deg) translate(' + radius + 'px) rotate(' + rotateReverse + 'deg)',
                });
            });

            // aggiorna le posizioni delle immagini
            $images.each(function (i) {
                var $self = $(this),
                    rotate = slice * i + start,
                    imageWidth = $self.width() / 2, // metà della larghezza dell'immagine
                    x = Math.cos(rotate * Math.PI / 180) * (radius_img + imageWidth),
                    y = Math.sin(rotate * Math.PI / 180) * (radius_img + imageWidth) * squashCoefficient;

                $self.css({
                    'transform': 'translate(' + x + 'px, ' + y + 'px) translate(-50%, -50%)',
                });
            });
        }

        updatePositions();

        $(window).resize(function () {
            updatePositions();
        });

        const logoWraps = document.querySelectorAll('.logo-wrap');

        logoWraps.forEach(logoWrap => {
            logoWrap.addEventListener('mouseover', function () {
                const index = this.getAttribute('data-index');
                const dot = document.querySelector(`.dot[data-index="${index}"]`);
                if (dot) {
                    dot.classList.add('is-active');
                }
            });

            logoWrap.addEventListener('mouseout', function () {
                const index = this.getAttribute('data-index');
                const dot = document.querySelector(`.dot[data-index="${index}"]`);
                if (dot) {
                    dot.classList.remove('is-active');
                }
            });
        });


        // animazione elementi
        gsap.set("section.group-info .circle-wrap", { autoAlpha: 0 });

        function animateElements(selector, delay, stagger) {
            const elements = gsap.utils.toArray(selector);

            gsap.set(elements, { autoAlpha: 0, scale: 0.8 });

            ScrollTrigger.create({
                trigger: "section.group-info .circle-wrap",
                start: "top bottom-=100",
                end: "bottom top+=100",
                onEnter: () => {

                    gsap.to("section.group-info .circle-wrap", {
                        autoAlpha: 1,
                        duration: 0.5,
                        onComplete: () => {
                            // anima gli elementi interni dopo il circle-wrap
                            gsap.to(elements, {
                                opacity: 1,
                                duration: 2,
                                autoAlpha: 1,
                                scale: 1,
                                stagger: stagger,
                                ease: "power2.out"
                            });
                        }
                    });
                },
                once: true
            });
        }

        // anima i dot
        animateElements('section.group-info .dot', 0.3, 0.1);

        // anima i loghi
        animateElements('section.group-info .logo-wrap', 0.3, 0.1);

        // animazione del logo centrale
        ScrollTrigger.create({
            trigger: "section.group-info .circle-wrap",
            start: "top bottom-=100",
            end: "bottom top+=100",
            onEnter: () => {
                gsap.fromTo("section.group-info .circle-logo",
                    { autoAlpha: 0, scale: 0.5 },
                    { duration: 3, autoAlpha: 1, scale: 1, ease: "elastic.out(1, 0.5)" }
                );
            },
            once: true
        });

    }

});


// animazione slider società
document.addEventListener("DOMContentLoaded", function () {

    let x = window.matchMedia("(min-width: 1351px)");

    if (document.querySelector('section.company-slider')/*  && !x.matches */) {

        var sliderWrap = document.querySelector("section.company-slider .slider-wrap");
        var $circle = $('.circle');
        var type = 1;
        var start = 248;
        var $elements = $('.circle .dots-wrap .dot');
        var $images = $('.circle-images .images-wrap img');
        var numberOfElements = (type === 1) ? $elements.length : $elements.length - 1;
        var slice = 360 * type / numberOfElements;
        var squashCoefficient = 0.90;
        const textsTrack = document.querySelector(".text-wrap.desktop");
        const textSlides = document.querySelector(".company-text");


        // funzione per animare gli elementi dell'infografica
        function animateCircularElements(selector, delay, stagger) {
            return new Promise((resolve) => {
                const elements = gsap.utils.toArray(selector);
                gsap.set(elements, { scale: 0.8 });

                let completedAnimations = 0;
                const totalAnimations = elements.length;

                elements.forEach((element, index) => {
                    gsap.to(element, {
                        scale: 1,
                        duration: 0.3,
                        delay: index * stagger,
                        ease: "power2.out",
                        onStart: () => {
                            element.classList.add('is-visible');
                        },
                        onComplete: () => {
                            completedAnimations++;
                            if (completedAnimations === totalAnimations) {
                                resolve();
                            }
                        }
                    });
                });
            });
        }

        // aggiorna le posizioni degli elementi
        function updatePositions() {
            var radius = $circle.width() / 2;
            var radius_img = ($circle.width() / 2) + 50;

            // aggiorna le posizioni degli elementi (dot)
            $elements.each(function (i) {
                var $self = $(this),
                    rotate = slice * i + start,
                    rotateReverse = rotate * -1;

                $self.css({
                    'transform': 'rotate(' + rotate + 'deg) translate(' + radius + 'px) rotate(' + rotateReverse + 'deg)',
                });
            });

            // aggiorna le posizioni delle immagini
            $images.each(function (i) {
                var $self = $(this),
                    rotate = slice * i + start,
                    imageWidth = $self.width() / 2, // metà della larghezza dell'immagine
                    x = Math.cos(rotate * Math.PI / 180) * (radius_img + imageWidth),
                    y = Math.sin(rotate * Math.PI / 180) * (radius_img + imageWidth) * squashCoefficient;

                $self.css({
                    'transform': 'translate(' + x + 'px, ' + y + 'px) translate(-50%, -50%)',
                });
            });
        }

        updatePositions();

        $(window).resize(function () {
            updatePositions();
        });



        if (x.matches) {

            let isClickNavigation = false;
            let currentIndex = 1;

            // scrolltrigger principale
            const mainTrigger = ScrollTrigger.create({
                id: 'mainTrigger',
                trigger: "section.company-slider",
                start: "top top",
                end: () => `+=350%`,
                pin: true,
                anticipatePin: 1,
                scrub: true,
                //markers: true,

                onLeave: () => {
                    gsap.killTweensOf(window);
                }

            });

            // timeline iniziale

            let tl1 = gsap.timeline({
                scrollTrigger: {
                    trigger: "section.company-slider",
                    start: "top top",
                    end: "+=20%",
                    scrub: 0.5,
                    once: true,
                }
            });
            tl1.to(".circle-logo svg", {
                scale: 1,
                onComplete: () => {
                    lenis.stop();
                }
            })
                .to("section.company-slider", {
                    backgroundColor: '#002B49',
                }, ">")
                .to("section.company-slider .circle", {
                    borderColor: '#00A7E1',
                    onStart: async () => {
                        await Promise.all([
                            animateCircularElements('section.company-slider .dot', 0.3, 0.1),
                            animateCircularElements('section.company-slider .logo-wrap', 0.3, 0.1)
                        ]);
                        sliderWrap.classList.add("is-active");
                        await activateSlider();
                        document.querySelector(".company-text").classList.add("is-active");
                        handleScrollAnimation();
                    },
                }, "<");



            function activateSlider() {
                return new Promise((resolve) => {
                    setTimeout(() => {
                        resolve();
                    }, 1000);
                });
            }




            // gestione dello scroll animation
            function handleScrollAnimation() {
                let sliderTl = gsap.timeline({
                    scrollTrigger: {
                        id: "mainTrigger", // Aggiungi questo ID
                        trigger: "section.company-slider",
                        start: "top top",
                        end: "+=300%",
                        scrub: 0.5,
                        onUpdate: (self) => {
                            if (!isClickNavigation) {
                                const progress = self.progress;
                                currentIndex = Math.floor(progress * (numberOfElements /* - 1 */)) + 1; // commentato "-1" per l'aggiunta di un elemento non visibile nel cerchio

                                const textContainer = document.querySelector('.text-wrap.desktop');
                                if (textContainer) {
                                    const textProgress = progress * (numberOfElements/*  - 1 */); // commentato "-1" per l'aggiunta di un elemento non visibile nel cerchio
                                    const activeTextIndex = Math.floor(textProgress);
                                    const translateY = -(activeTextIndex * 100);

                                    gsap.to(textContainer, {
                                        y: `${translateY}%`,
                                        duration: 0.5,
                                        ease: "power2.out",
                                    });
                                }

                                updateActiveElements(currentIndex);
                            }
                            lenis.start();
                        },
                    }
                });
            }

            document.querySelectorAll('.dot, .logo-wrap').forEach((item, index) => {
                item.addEventListener('click', () => {
                    gsap.to(window, {
                        scrollTo: { y: textSlides[index], offsetY: 0 },
                        duration: 0.5,
                    });
                });
            });


            function updateActiveElements(index, progress = 1) {

                sliderWrap.querySelectorAll('.logo-wrap, .dot').forEach(element => {
                    const elementIndex = parseInt(element.getAttribute('data-index'));
                    if (elementIndex === index) {
                        element.classList.add('is-active');
                    } else {
                        element.classList.remove('is-active');
                    }
                });

                sliderWrap.querySelectorAll('.company-text').forEach(element => {
                    const elementIndex = parseInt(element.getAttribute('data-index'));

                });
            }

            // gestione dei click
            function handleElementClick(event) {
                const clickedElement = event.target.closest('.dot, .logo-wrap');
                if (!clickedElement || isClickNavigation) return;

                const clickedIndex = parseInt(clickedElement.getAttribute('data-index'));
                if (isNaN(clickedIndex)) return;

                isClickNavigation = true;
                currentIndex = clickedIndex;


                const translateY = -((clickedIndex - 1) * 100);


                const st = ScrollTrigger.getById("mainTrigger");
                if (st) {
                    // calcola la nuova posizione di scroll basata sull'indice
                    const progress = (clickedIndex - 1) / (numberOfElements - 1);
                    const newScrollPosition = st.start + (st.end - st.start) * progress;


                    // aggiorna sia lo scroll che il translateY
                    gsap.to(window, {
                        scrollTo: newScrollPosition,
                        duration: 0.5,
                        ease: "power2.out",
                        onComplete: () => {
                            updateActiveElements(clickedIndex);
                            isClickNavigation = false;
                        }
                    });

                    // aggiorna la posizione del testo
                    const textContainer = document.querySelector('.text-wrap.desktop');
                    if (textContainer) {
                        gsap.to(textContainer, {
                            y: `${translateY}%`,
                            duration: 0.5,
                            ease: "power2.out",
                            onComplete: () => {
                                updateActiveElements(clickedIndex);
                                setTimeout(() => {
                                    isClickNavigation = false;
                                }, 100);
                            }
                        });
                    }
                }
            }

            sliderWrap.addEventListener('click', handleElementClick);


        } else {


            /********************* START MOBILE *******************/

            const logoWraps = document.querySelectorAll('.logo-wrap');

            // animazione del logo centrale
            ScrollTrigger.create({
                trigger: "section.company-slider .circle-wrap",
                start: "top bottom-=100",
                end: "bottom top+=100",
                //markers: true,
                onEnter: () => {
                    gsap.fromTo("section.company-slider .circle-logo",
                        { autoAlpha: 0, scale: 0.5 },
                        { autoAlpha: 1, scale: 1, ease: "elastic.out(1, 0.5)" },
                    );
                    // anima i dot
                    animateCircularElements('section.company-slider .dot', 0.3, 0.1);
                    // anima i loghi
                    animateCircularElements('section.company-slider .logo-wrap', 0.3, 0.1);
                },
                once: true
            });


            logoWraps.forEach(logoWrap => {
                logoWrap.addEventListener('mouseover', function () {
                    const index = this.getAttribute('data-index');
                    const dot = document.querySelector(`.dot[data-index="${index}"]`);
                    if (dot) {
                        dot.classList.add('is-active');
                    }
                });

                logoWrap.addEventListener('mouseout', function () {
                    const index = this.getAttribute('data-index');
                    const dot = document.querySelector(`.dot[data-index="${index}"]`);
                    if (dot) {
                        dot.classList.remove('is-active');
                    }
                });
            })


            var groupSlider = new Splide(".text-wrap.mobile", {
                type: "loop",
                perPage: 1,
                gap: '2rem',
                pagination: true,
                autoHeight: true,
                arrows: false,
                perMove: 1,
                focus: 0,
                speed: 500,
            }).mount();

            function initImagePagination() {
                const logoWraps = document.querySelectorAll('.logo-wrap, .dot');


                groupSlider.on('moved', function (newIndex) {
                    logoWraps.forEach(wrap => {
                        wrap.classList.remove('is-active-pag');

                        if (parseInt(wrap.getAttribute('data-index')) === newIndex + 1) {
                            wrap.classList.add('is-active-pag');
                        }
                    });
                });

                logoWraps.forEach(wrap => {
                    wrap.addEventListener('click', function () {
                        const index = parseInt(this.getAttribute('data-index')) - 1;

                        groupSlider.go(index);


                        logoWraps.forEach(w => {
                            w.classList.remove('is-active');
                            w.classList.remove('is-active-pag');
                        });
                        this.classList.add('is-active');
                        this.classList.add('is-active-pag');
                    });
                });


                const initialActiveWrap = document.querySelector(`.logo-wrap[data-index="${groupSlider.index + 1}"], .dot[data-index="${groupSlider.index + 1}"]`);
                if (initialActiveWrap) {
                    initialActiveWrap.classList.add('is-active-pag');
                }
            }

            initImagePagination();

            /********************* END MOBILE *******************/

        }

    }

});

// uniforma altezza titoli blocco valori
document.addEventListener('DOMContentLoaded', function () {
    let x = window.matchMedia("(min-width: 700px)");

    if (x.matches) {
        const h4Elements = document.querySelectorAll('.vantaggio .text');

        let maxHeight = 0;
        h4Elements.forEach(h4 => {
            const height = h4.offsetHeight;
            maxHeight = Math.max(maxHeight, height);
        });

        h4Elements.forEach(h4 => {
            h4.style.height = maxHeight + 'px';
        });
    }
});



/* document.addEventListener('DOMContentLoaded', () => {
    const colWraps = document.querySelectorAll('.double-banner .col-wrap');

    let x = window.matchMedia("(max-width: 1300px)");

    if (colWraps && !x.matches) {

        colWraps.forEach(col => {
            const hiddenContent = col.querySelector('.hidden-content');
            const hiddenWrap = col.querySelector('.hidden-wrap');
            const height = hiddenContent.offsetHeight;

            const setHeight = () => {
                hiddenWrap.style.height = `${height}px`;
            }

            const removeHeight = () => {
                hiddenWrap.style.height = 0;
            }

            col.addEventListener('mouseover', () => {
                setHeight();
                col.classList.add('is-active');
                setTimeout(() => {
                    hiddenContent.classList.add('is-active');
                }, 100);
            });
            col.addEventListener('mouseleave', () => {
                hiddenContent.classList.add('is-active');

                setTimeout(() => {
                    removeHeight();
                }, 100);

                setTimeout(() => {
                    col.classList.remove('is-active');
                }, 400);
            });

            window.addEventListener('resize', setHeight);
        });
    }
}); */




// animazione post type grid

/* document.addEventListener("DOMContentLoaded", function () {
    var postTypeGrids = document.querySelectorAll('section.post-type-grid .tease');

    if (postTypeGrids) {
        function updateTextMargin() {
            postTypeGrids.forEach(function (tease) {
                const labelTease = tease.querySelector('label');
                const hiddenContent = tease.querySelector('.hidden-content');
                const hiddenWrap = tease.querySelector('.hidden-wrap');
                const textElement = tease.querySelector('.text-wrap');
                var radioBtns = tease.querySelector('input[type="checkbox"]');


                radioBtns.addEventListener('click', function () {
                    const isActive = hiddenContent.classList.contains('is-active');


                    postTypeGrids.forEach(function (otherTease) {
                        const otherLabelTease = otherTease.querySelector('label');
                        const otherHiddenContent = otherTease.querySelector('.hidden-content');
                        const otherHiddenWrap = otherTease.querySelector('.hidden-wrap');
                        const otherTextElement = otherTease.querySelector('.text-wrap');
                        otherHiddenContent.classList.remove('is-active');
                        otherHiddenWrap.style.height = 0;
                        otherTextElement.classList.remove('is-active');
                        otherLabelTease.classList.remove('is-active');
                    });

                    if (!isActive) {
                        const height = hiddenContent.offsetHeight;
                        hiddenWrap.style.height = `${height}px`;
                        hiddenContent.classList.add('is-active');
                        textElement.classList.add('is-active');
                        labelTease.classList.add('is-active');
                    }
                });
            });
        }

        updateTextMargin();

        window.addEventListener('resize', updateTextMargin);
    }
}); */


AOS.init({
    startEvent: 'DOMContentLoaded',
    //once: true,
});



document.addEventListener("DOMContentLoaded", function () {

    var numbersCarousel = document.querySelector("section.numbers-carousel");

    if (numbersCarousel) {
        numbersCarousel = new Splide("section.numbers-carousel", {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            perPage: 3,
            gap: '5rem',
            pagination: false,
            autoHeight: true,
            arrows: false,
            autoScroll: {
                speed: 1.8,
                pauseOnHover: false,
            },
            breakpoints: {
                1920: {
                    perPage: 2
                },
                800: {
                    perPage: 1
                }
            }
        }).mount({ AutoScroll });
    }
});


document.addEventListener("DOMContentLoaded", function () {

    var autoscrollCarousel = document.querySelector("section.autoscroll-carousel");

    if (autoscrollCarousel) {
        autoscrollCarousel = new Splide("section.autoscroll-carousel", {
            type: 'loop',
            perPage: 4,
            perMove: 1,
            gap: '40px',
            pagination: false,
            autoHeight: true,
            arrows: true,
            padding: { left: '5rem', right: '5rem' },
            breakpoints: {
                1750: {
                    perPage: 3
                },
                1220: {
                    perPage: 2
                },
                830: {
                    perPage: 1,
                    padding: { left: '0', right: '5rem' }
                },
                500: {
                    gap: '20px',
                    perPage: 1,
                    padding: { left: '0', right: '3rem' }
                }
            }
        }).mount();
    }
});


document.addEventListener("DOMContentLoaded", function () {

    var galleryCarousel = document.querySelector("section.gallery");

    if (galleryCarousel) {
        galleryCarousel = new Splide("section.gallery", {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            perPage: 3,
            gap: '40px',
            pagination: false,
            autoHeight: true,
            arrows: false,
            autoScroll: {
                speed: 1,
                pauseOnHover: false
            },
            breakpoints: {
                1550: {
                    perPage: 2
                },
                1000: {
                    perPage: 1
                }
            }
        }).mount({ AutoScroll });
    }
});


document.addEventListener("DOMContentLoaded", function () {

    var techCarousel = document.querySelector("section.tech-carousel .wrapper");

    if (techCarousel) {
        techCarousel = new Splide("section.tech-carousel .wrapper", {
            drag: 'free',
            perPage: 3,
            gap: '20px',
            padding: {
                right: '15rem'
            },
            pagination: false,
            autoHeight: true,
            arrows: true,
            breakpoints: {
                1920: {
                    perPage: 2
                },
                992: {
                    perPage: 1,
                    padding: {
                        right: '0'
                    },
                },

            }
        }).mount();
    }
});



document.addEventListener("DOMContentLoaded", function () {

    var caseCarousel = document.querySelector("section.case-study-slider");

    if (caseCarousel) {
        caseCarousel = new Splide("section.case-study-slider", {
            drag: false,
            focus: 'center',
            perPage: 1,
            pagination: false,
            autoHeight: true,
            arrows: true,
            speed: 1000
        }).mount();
    }
});


const bannerAnimation = () => {
    const bannerSection = document.querySelector('.banner');
    const maskWrap = document.querySelector('.banner .mask-wrap');

    if (!bannerSection || !maskWrap) return;

    const isMobile = window.matchMedia('(max-width: 992px)').matches;
    const startRadius = isMobile ? '18%' : '15%';

    gsap.fromTo(maskWrap,
        { clipPath: `circle(${startRadius} at 50% 50%)` },
        {
            scrollTrigger: {
                trigger: bannerSection,
                start: 'top top',
                end: '+=100%',
                scrub: 1,
                pin: true,
                markers: false
            },
            clipPath: 'circle(100% at 50% 50%)',
            ease: 'none'
        }
    );
};

document.addEventListener('DOMContentLoaded', bannerAnimation);




document.addEventListener("DOMContentLoaded", function () {
    const dotWraps = document.querySelectorAll('.dot-wrap');

    if (dotWraps.length) {
        dotWraps.forEach(dotWrap => {
            gsap.to(dotWrap, {
                scrollTrigger: {
                    trigger: dotWrap,
                    start: "top bottom-=200px",
                    end: "bottom top",
                    onEnter: () => dotWrap.classList.add('is-active'),
                    once: true // esegui l'animazione una sola volta
                }
            });
        });
    }
});




// AJAX filtri news & realizzazioni
document.addEventListener("DOMContentLoaded", function () {

    function setLoadingState(isLoading) {
        var loadingScreen = document.querySelector('.loading');
        if (isLoading) {
            loadingScreen.style.display = 'flex';
        } else {
            loadingScreen.style.display = 'none';
        }
    }

    var action = 'filter_careers';

    if (document.querySelector(".loop-wrap") != null) {

        var activeFilters = [];
        var currentUrl = window.location.href;
        var baseUrl = "/";
        var isFilterApplied = false;

        if (currentUrl.indexOf("/it/") !== -1) {
            baseUrl = "/it/";
        } else if (currentUrl.indexOf("/en/") !== -1) {
            baseUrl = "/en/";
        }


        $(".js-filter").on("click", function () {

            var term = $(this).data("term");


            if (activeFilters.includes(term)) {
                var index = activeFilters.indexOf(term);
                activeFilters.splice(index, 1);
            } else {
                activeFilters.push(term);
            }


            $(this).toggleClass("is-active");
            $(".js-clear-filters").removeClass("is-active");

            applyFilters();

            setLoadingState(true);
            $.ajax({
                url: baseUrl + "wp-admin/admin-ajax.php",
                data: {
                    action: action,
                    term: activeFilters,
                },
                type: "post",
                success: function (result) {
                    $(".ajax__posts").html(result);

                    // reinizializza gli event listener per form__trigger dopo l'aggiornamento ajax
                    var triggerOpen = document.querySelectorAll(".form__trigger");
                    triggerOpen.forEach((el) => {
                        el.addEventListener("click", () => {
                            lenis.stop();
                            openNav();
                        });
                    });

                    // reinizializza gli event listener sui .tease-career caricati via ajax
                    var teaseCareer = document.querySelectorAll('.tease-career');
                    teaseCareer.forEach((el) => {
                        el.addEventListener("click", () => {
                            var titleText = el.querySelector('.title').textContent.trim();
                            var selectElement = document.querySelector('.wpcf7-select');

                            if (selectElement) {
                                const option = Array.from(selectElement.options).find(opt => opt.text === titleText);
                                if (option) {
                                    selectElement.value = option.value;
                                }
                            }
                        });
                    });

                    AOS.refresh();

                    setLoadingState(false);
                },
                error: function () {
                    setLoadingState(false);
                }
            });

            updateLoadMoreStatus();
        });


        $(".js-clear-filters").on("click", function () {
            activeFilters = [];

            $(".js-filter").removeClass("is-active");
            $(this).addClass("is-active");

            applyFilters();

            setLoadingState(true);


            $.ajax({
                url: baseUrl + "wp-admin/admin-ajax.php",
                data: {
                    action: action,
                    term: activeFilters,
                },
                type: "post",
                success: function (result) {
                    $(".ajax__posts").html(result);

                    // reinizializza gli event listener per form__trigger dopo l'aggiornamento ajax
                    var triggerOpen = document.querySelectorAll(".form__trigger");
                    triggerOpen.forEach((el) => {
                        el.addEventListener("click", () => {
                            lenis.stop();
                            openNav();
                        });
                    });

                    // reinizializza gli event listener sui .tease-career caricati via ajax
                    var teaseCareer = document.querySelectorAll('.tease-career');
                    teaseCareer.forEach((el) => {
                        el.addEventListener("click", () => {
                            var titleText = el.querySelector('.title').textContent.trim();
                            var selectElement = document.querySelector('.wpcf7-select');

                            if (selectElement) {
                                const option = Array.from(selectElement.options).find(opt => opt.text === titleText);
                                if (option) {
                                    selectElement.value = option.value;
                                }
                            }
                        });
                    });

                    AOS.refresh();

                    setLoadingState(false);
                    updateLoadMoreStatus();
                },
                error: function () {
                    setLoadingState(false);
                }
            });
        });

    }

    // load more
    $(".js-load-more").on("click", function () {
        var newsContainer = $('.loop');
        var postsPerPage = 18;
        var currentPage = parseInt(newsContainer.attr('data-page'), 10) || 1;
        var offset = $(".ajax__posts .loop-item").length ?? 0;


        setLoadingState(true);


        if (Object.keys(activeFilters).length === 0) {
            currentPage++;
            newsContainer.attr('data-page', currentPage);
            offset = (currentPage - 1) * postsPerPage;
        }

        $.ajax({
            url: baseUrl + "wp-admin/admin-ajax.php",
            data: {
                action: action,
                term: activeFilters,
                offset: offset,
                posts_per_page: postsPerPage,
                paged: currentPage
            },
            type: "POST",
            success: function (result, textStatus, xhr) {
                var remainingNews = parseInt(xhr.getResponseHeader('X-WP-RemainingNews'), 10);
                $(".ajax__posts").append(result);



                AOS.refresh();

                setLoadingState(false);

                if (remainingNews <= 0) {
                    $(".js-load-more").hide();
                }
            },
            error: function () {
                setLoadingState(false);
                console.log("Something went wrong with the AJAX request.");
            }
        });
    });

    function updateLoadMoreStatus() {
        var newsContainer = $('.loop');
        var currentPage = parseInt(newsContainer.attr('data-page')) || 1;
        var postsPerPage = 18;
        setLoadingState(true);

        $.ajax({
            url: baseUrl + "wp-admin/admin-ajax.php",
            data: {
                action: action,
                term: activeFilters,
                offset: (currentPage - 1) * postsPerPage,
                posts_per_page: postsPerPage
            },
            type: "post",
            success: function (result, textStatus, xhr) {
                var remainingNews = parseInt(xhr.getResponseHeader('X-WP-RemainingNews'), 10);

                setLoadingState(false);

                if (remainingNews > 0) {
                    $(".js-load-more").show();
                } else {
                    $(".js-load-more").hide();
                }
            },
            error: function () {
                setLoadingState(false);
            }
        });
    }


    function resetPagination() {
        $('.loop').attr('data-page', 1);
        isFilterApplied = false;
    }

    function applyFilters() {
        resetPagination();
        updateLoadMoreStatus();
        isFilterApplied = true;
        loadFilteredNews();
    }
    function loadFilteredNews() {
        setLoadingState(true);
        var newsContainer = $('.loop');
        var postsPerPage = 18;
        var currentPage = 1;
        var offset = 0;
        $.ajax({
            url: baseUrl + "wp-admin/admin-ajax.php",
            data: {
                action: action,
                term: activeFilters,
                offset: offset,
                posts_per_page: postsPerPage,
                paged: currentPage
            },
            type: "POST",
            success: function (result, textStatus, xhr) {
                var remainingNews = parseInt(xhr.getResponseHeader('X-WP-RemainingNews'), 10);

                if (remainingNews > 0) {
                    $(".js-load-more").show();
                } else {
                    $(".js-load-more").hide();
                }
            },
            error: function () {
                setLoadingState(false);
                console.log("Something went wrong with the AJAX request.");
            }
        });
    }

});



// chiude il dropdown dei filtri al click sul filtro
/* document.addEventListener('DOMContentLoaded', function () {
    const dropdownCheckbox = document.getElementById('dropdown');
    const filterItems = document.querySelectorAll('.js-filter, .js-clear-filters');
    if (dropdownCheckbox) {
        filterItems.forEach(item => {
            item.addEventListener('click', () => {
                dropdownCheckbox.checked = false;
            });
        });
    }
}); */

document.addEventListener('DOMContentLoaded', function () {
    const dropdownCheckbox = document.getElementById('dropdown');
    const filterItems = document.querySelectorAll('.js-filter, .js-clear-filters');
    const filterLabel = document.querySelector('label.for-dropdown span');

    if (dropdownCheckbox && filterLabel) {
        filterItems.forEach(item => {
            item.addEventListener('click', () => {

                //console.log(item);
                dropdownCheckbox.checked = false;
                // aggiorna il testo della label con il testo del filtro cliccato
                filterLabel.textContent = item.textContent.trim();
            });
        });
    }
});

// side nav form
const sideNavOverlay = document.querySelector(".form-overlay");

function openNav() {
    document.getElementById("form-nav").style.transform = "translateX(0)";
    sideNavOverlay.style.display = "block";
    setTimeout(() => {
        sideNavOverlay.style.backgroundColor = "rgba(0,0,0,0.2)";
    }, 100);
    document.addEventListener('wheel', handleMouseWheel, { passive: false });
    document.addEventListener('touchmove', handleTouchMove, { passive: true });

}

function closeNav() {
    document.getElementById("form-nav").style.transform = "translateX(100%)";
    document.body.style.backgroundColor = "#fff";
    sideNavOverlay.style.backgroundColor = "rgba(0,0,0,0.0)";
    setTimeout(() => {
        sideNavOverlay.style.display = "none";
    }, 550);

    document.removeEventListener('wheel', handleMouseWheel);
    document.removeEventListener('touchmove', handleTouchMove);

}

const handleMouseWheel = function (event) {
    var sideNav = document.querySelector('.form-sidenav');
    if (sideNav.contains(event.target)) {
        sideNav.scrollBy({
            top: event.deltaY,
        });
        event.preventDefault();
    }
};

const handleTouchMove = function (event) {
    var sideNav = document.querySelector('.form-sidenav');
    if (sideNav.contains(event.target)) {
        event.stopPropagation();
    }
};


document.addEventListener("DOMContentLoaded", () => {
    var triggerOpen = document.querySelectorAll(".form__trigger");
    var triggerClose = document.querySelector(".form__close");
    var triggerCloseOverlay = document.querySelector(".form-overlay");

    const sideNav = document.querySelector('.form-sidenav');



    if (triggerOpen && triggerClose) {
        triggerOpen.forEach((el) => {
            el.addEventListener("click", () => {
                lenis.stop();
                openNav();
            });
        })

        triggerClose.addEventListener("click", () => {
            lenis.start();
            closeNav();
        });

        triggerCloseOverlay.addEventListener("click", () => {
            lenis.start();
            closeNav();
        });
    }

});



// lavora con noi masonry

document.addEventListener("DOMContentLoaded", function () {
    var viewMoreBtn = document.querySelector(".view-more-button");

    if (document.querySelector(".ajax__posts") != null) {
        var macyInstance = Macy({
            container: ".ajax__posts",
            columns: 3,
            trueOrder: true,
            margin: 40,
            waitForImages: false,
            breakAt: {
                1919: {
                    columns: 3,
                },
                1440: {
                    columns: 2,
                },
                850: {
                    columns: 1,
                },
            },
        });

        macyInstance.runOnImageLoad(function () {
            macyInstance.recalculate(true);
        }, true);

        // funzione da eseguire quando viene rilevato un cambiamento nel DOM
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === "childList") {
                    if (mutation.addedNodes.length > 0) {
                        macyInstance.runOnImageLoad(function () {
                            macyInstance.recalculate(true);
                        }, true);
                    }
                }
            }
        });

        // Opzioni per l'observer
        const observerOptions = {
            childList: true,
            subtree: true,
        };

        // Avvia l'observer sulla radice del documento
        observer.observe(document.body, observerOptions);
    }
});



// funzione per troncare il testo
function truncateBreadcrumb() {
    const breadcrumb = document.querySelector('.custom-breadcrumb');
    if (!breadcrumb) return;

    const links = breadcrumb.querySelectorAll('a');
    let totalWidth = 0;
    const maxWidth = breadcrumb.clientWidth;

    links.forEach((link, index) => {
        if (totalWidth + link.offsetWidth > maxWidth && index !== links.length - 1) {
            // tronca il testo mantenendo l'ultimo elemento intatto
            link.textContent = link.textContent.substring(0, 10) + '...';
        }
        totalWidth += link.offsetWidth;
    });
}

window.addEventListener('DOMContentLoaded', truncateBreadcrumb);
window.addEventListener('resize', debounce(truncateBreadcrumb, 100));

// aggiunge una funzione debounce per ottimizzare le prestazioni
function debounce(func, wait) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}



document.addEventListener("DOMContentLoaded", function () {

    var teaseCareer = document.querySelectorAll('.tease-career');

    teaseCareer.forEach((el) => {
        el.addEventListener("click", () => {
            var titleText = el.querySelector('.title').textContent.trim();
            var selectElement = document.querySelector('.wpcf7-select');

            if (selectElement) {
                // cerca l'opzione con lo stesso valore del testo
                const option = Array.from(selectElement.options).find(opt => opt.text === titleText);
                if (option) {
                    selectElement.value = option.value;
                }
            }
        });
    });

});



document.addEventListener('DOMContentLoaded', function () {


    const slidingGroupWrap = document.querySelector('.sliding-group-wrap');

    if (slidingGroupWrap) {

        const triggerOpen = document.querySelectorAll('.trigger__open, .trigger__open-mobile');
        const triggerSlidingClose = document.querySelector('.trigger__close');
        const slidingOverlay = document.querySelector('.sliding-group-wrap-overlay');

        // seleziona l'elemento da osservare
        const slidingWrapper = document.querySelector('.sliding-group-wrap .wrapper');

        // funzione per verificare l'overflow
        function checkOverflow(el) {
            // controlla se il contenuto eccede le dimensioni dell'elemento
            return el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
        }

        // callback per il MutationObserver
        const slidingObserver = new MutationObserver(() => {
            if (checkOverflow(slidingWrapper)) {
                slidingWrapper.classList.add('overflow');
            } else {
                slidingWrapper.classList.remove('overflow');
            }
        });

        // opzioni di osservazione: cambiamenti ai figli e ai nodi discendenti
        slidingObserver.observe(slidingWrapper, { childList: true, subtree: true });

        // opzionalmente, osserva anche i cambiamenti di dimensione
        const resizeObserver = new ResizeObserver(() => {
            if (checkOverflow(slidingWrapper)) {
                slidingWrapper.classList.add('overflow');
            } else {
                slidingWrapper.classList.remove('overflow');
            }
        });
        resizeObserver.observe(slidingWrapper);

        const handleSlidingCtaMouseWheel = function (event) {
            var slidingNav = document.querySelector('.sliding-group-wrap .wrapper');
            if (slidingNav.contains(event.target)) {
                slidingNav.scrollBy({
                    top: event.deltaY,
                });
                event.preventDefault();
            }
        };

        const handleSlidingCtaTouchMove = function (event) {
            var slidingNav = document.querySelector('.sliding-group-wrap .wrapper');
            if (slidingNav.contains(event.target)) {
                event.stopPropagation();
            }
        };

        setTimeout(() => {
            slidingGroupWrap.classList.add('visible');
        }, 1500);

        triggerOpen.forEach(trigger => {
            trigger.addEventListener('click', function () {
                slidingGroupWrap.classList.add('is__active');
                slidingOverlay.classList.add('is__active');

                lenis.stop();
                document.addEventListener('wheel', handleSlidingCtaMouseWheel, { passive: false });
                document.addEventListener('touchmove', handleSlidingCtaTouchMove, { passive: true });
            });
        });

        triggerSlidingClose.addEventListener('click', function () {
            slidingGroupWrap.classList.remove('is__active');
            slidingOverlay.classList.remove('is__active');

            lenis.start();
            document.removeEventListener('wheel', handleSlidingCtaMouseWheel);
            document.removeEventListener('touchmove', handleSlidingCtaTouchMove);
        });

        slidingOverlay.addEventListener('click', function () {
            slidingGroupWrap.classList.remove('is__active');
            slidingOverlay.classList.remove('is__active');

            lenis.start();
            document.removeEventListener('wheel', handleSlidingCtaMouseWheel);
            document.removeEventListener('touchmove', handleSlidingCtaTouchMove);
        });
    }

});



